// blogPosts.js

const BLOG_POSTS = [
  // Technology Category
  {
    id: 1,
    title: "The Internet: Connecting the World",
    excerpt: "The revolutionary network that transformed global communication, commerce, and information sharing, changing how humanity interacts forever.",
    category: "Technology",
    author: "Tim Berners-Lee",
    date: "2024-01-15",
    readTime: "14 min read",
    image: "/media/technologyImg/Tim Berners-Lee.jpg",
    tags: ["internet", "networking", "communication", "innovation", "Tim Berners-Lee"]
  },
  {
    id: 2,
    title: "iPhone: Revolutionizing Mobile Technology",
    excerpt: "Apple's groundbreaking smartphone that redefined mobile computing and launched the modern app economy, changing how we interact with technology.",
    category: "Technology",
    author: "Steve Jobs",
    date: "2024-01-20",
    readTime: "12 min read",
    image: "/media/technologyImg/Steve-Jobs.avif",
    tags: ["iphone", "apple", "smartphone", "mobile", "innovation", "Steve Jobs"]
  },
  {
    id: 3,
    title: "Google Search: Organizing World's Information",
    excerpt: "The algorithm that revolutionized how we find information online, making the vast resources of the internet instantly accessible to everyone.",
    category: "Technology",
    author: "Larry Page & Sergey Brin",
    date: "2024-01-25",
    readTime: "10 min read",
    image: "/media/technologyImg/Larry-Page&Sergey-Brin.jpg",
    tags: ["google", "search", "algorithm", "information", "Larry Page & Sergey Brin"]
  },
  {
    id: 4,
    title: "Facebook: Social Networking Revolution",
    excerpt: "The platform that connected billions of people worldwide, fundamentally changing how we share experiences and maintain relationships.",
    category: "Technology",
    author: "Mark Zuckerberg",
    date: "2024-02-01",
    readTime: "11 min read",
    image: "/media/technologyImg/Mark-Zuckerberg.webp",
    tags: ["facebook", "social media", "networking", "connection, Mark Zuckerberg, social networking, Zuckerberg"]
  },
  {
    id: 5,
    title: "Tesla Electric Vehicles: Sustainable Transportation",
    excerpt: "Elon Musk's vision of electric mobility that accelerated the global transition to sustainable transportation and clean energy.",
    category: "Technology",
    author: "Elon Musk",
    date: "2024-02-05",
    readTime: "13 min read",
    image: "/media/technologyImg/Elon-Musk.jpg",
    tags: ["tesla", "electric vehicles", "sustainability", "innovation", "Elon Musk"]
  },
  {
    id: 6,
    title: "Amazon Web Services: Cloud Computing Pioneer",
    excerpt: "The platform that democratized enterprise computing power, enabling startups and corporations to scale without massive infrastructure investments.",
    category: "Technology",
    author: "Jeff Bezos",
    date: "2024-02-10",
    readTime: "9 min read",
    image: "/media/technologyImg/Jeff-Bezos.webp",
    tags: ["aws", "cloud computing", "amazon", "infrastructure", "Jeff Bezos", "cloud services", "Jeff"]
  },
  {
    id: 7,
    title: "YouTube: Video Sharing Revolution",
    excerpt: "The platform that transformed content creation and consumption, giving everyone the power to broadcast to a global audience.",
    category: "Technology",
    author: "Chad Hurley, Steve Chen & Jawed Karim",
    date: "2024-02-15",
    readTime: "8 min read",
    image: "/media/technologyImg/Chad-Hurley, Steve-Chen&Jawed-Karim.jpeg",
    tags: ["youtube", "video sharing", "content creation", "media", "Chad Hurley, Steve Chen & Jawed Karim"]
  },
  {
    id: 8,
    title: "Netflix Streaming: Entertainment Revolution",
    excerpt: "The service that disrupted traditional television and movie distribution, pioneering the on-demand streaming entertainment model.",
    category: "Technology",
    author: "Reed Hastings & Marc Randolph",
    date: "2024-02-20",
    readTime: "10 min read",
    image: "/media/technologyImg/Reed-Hastings&Marc-Randolph.webp",
    tags: ["netflix", "streaming", "entertainment", "disruption", "Reed Hastings & Marc Randolph"]
  },
  {
    id: 9,
    title: "Spotify: Music Streaming Innovation",
    excerpt: "The platform that revolutionized music consumption, making millions of songs instantly accessible while supporting artists through digital distribution.",
    category: "Technology",
    author: "Daniel Ek & Martin Lorentzon",
    date: "2024-02-25",
    readTime: "7 min read",
    image: "/media/technologyImg/Daniel-Ek.jpg",
    tags: ["spotify", "music streaming", "digital music", "audio", "Daniel Ek & Martin Lorentzon"]
  },
  {
    id: 10,
    title: "Uber: Ride-Sharing Innovation",
    excerpt: "The app that transformed urban transportation, creating the gig economy model and changing how people move around cities worldwide.",
    category: "Technology",
    author: "Travis Kalanick & Garrett Camp",
    date: "2024-03-01",
    readTime: "9 min read",
    image: "/media/technologyImg/Travis-Kalanick&Garrett-Camp.webp",
    tags: ["uber", "ride sharing", "transportation", "gig economy", "Travis Kalanick & Garrett Camp"]
  },
  {
    id: 11,
    title: "WhatsApp: Global Messaging Revolution",
    excerpt: "The messaging app that connected billions across borders, making international communication free and instant for everyone with a smartphone.",
    category: "Technology",
    author: "Brian Acton & Jan Koum",
    date: "2024-03-05",
    readTime: "6 min read",
    image:"/media/technologyImg/Brian-Acton&Jan-Koum.jpg",
    tags: ["whatsapp", "messaging", "communication", "global", "Brian Acton & Jan Koum"]
  },
  {
    id: 12,
    title: "Zoom: Remote Communication Platform",
    excerpt: "The video conferencing solution that enabled remote work and learning during the pandemic, fundamentally changing how we collaborate.",
    category: "Technology",
    author: "Eric Yuan",
    date: "2024-03-10",
    readTime: "8 min read",
    image: "/media/technologyImg/Eric-Yuan.webp",
    tags: ["zoom", "video conferencing", "remote work", "collaboration", "Eric Yuan"]
  },
  {
    id: 13,
    title: "Slack: Workplace Communication Revolution",
    excerpt: "The platform that transformed team communication in the digital workplace, replacing email with organized, searchable conversations.",
    category: "Technology",
    author: "Stewart Butterfield",
    date: "2024-03-15",
    readTime: "7 min read",
    image: "/media/technologyImg/Stewart-Butterfield.webp",
    tags: ["slack", "workplace communication", "team collaboration", "productivity", "Stewart Butterfield"]
  },
  {
    id: 14,
    title: "Airbnb: Sharing Economy Pioneer",
    excerpt: "The platform that revolutionized travel accommodation, enabling anyone to become a host and transforming the hospitality industry.",
    category: "Technology",
    author: "Brian Chesky, Joe Gebbia & Nathan Blecharczyk",
    date: "2024-03-20",
    readTime: "10 min read",
    image: "/media/technologyImg/Brian-Chesky, Joe-Gebbia&Nathan-Blecharczyk.webp",
    tags: ["airbnb", "sharing economy", "travel", "hospitality", "Brian Chesky, Joe Gebbia & Nathan Blecharczyk"]
  },
  {
    id: 15,
    title: "PayPal: Digital Payment Revolution",
    excerpt: "The service that pioneered secure online payments, enabling e-commerce growth and digital financial transactions worldwide.",
    category: "Technology",
    author: "Peter Thiel & Max Levchin",
    date: "2024-03-25",
    readTime: "9 min read",
    image: "/media/technologyImg/Peter-Thiel&Max-Levchin.jpg",
    tags: ["paypal", "digital payments", "fintech", "e-commerce", "Peter Thiel & Max Levchin"]
  },
  {
    id: 16,
    title: "Bitcoin: Cryptocurrency Innovation",
    excerpt: "The first successful digital currency that introduced blockchain technology and challenged traditional financial systems worldwide.",
    category: "Technology",
    author: "Satoshi Nakamoto",
    date: "2024-03-30",
    readTime: "12 min read",
    image: "/media/technologyImg/Satoshi-Nakamoto.jpg",
    tags: ["bitcoin", "cryptocurrency", "blockchain", "digital currency", "Satoshi Nakamoto"]
  },
  {
    id: 17,
    title: "Instagram: Visual Social Media",
    excerpt: "The photo-sharing app that transformed social media into a visual medium, influencing culture, marketing, and personal expression.",
    category: "Technology",
    author: "Kevin Systrom & Mike Krieger",
    date: "2024-04-01",
    readTime: "8 min read",
    image: "/media/technologyImg/Kevin-Systrom&Mike-Krieger.jpg",
    tags: ["instagram", "photo sharing", "visual media", "social networking", "Kevin Systrom & Mike Krieger"]
  },
  {
    id: 18,
    title: "TikTok: Short-Form Video Revolution",
    excerpt: "The platform that revolutionized content creation with short-form videos, influencing global culture and redefining viral entertainment.",
    category: "Technology",
    author: "Zhang Yiming",
    date: "2024-04-05",
    readTime: "9 min read",
    image: "/media/technologyImg/Zhang-Yiming.avif",
    tags: ["tiktok", "short video", "viral content", "social media", "Zhang Yiming"]
  },
  {
    id: 19,
    title: "Twitter: Microblogging Platform",
    excerpt: "The service that created real-time global conversations through 280-character messages, influencing news, politics, and public discourse.",
    category: "Technology",
    author: "Jack Dorsey, Noah Glass, Biz Stone & Evan Williams",
    date: "2024-04-10",
    readTime: "7 min read",
    image: "/media/technologyImg/Jack-Dorsey Noah-Glass Biz-Stone&Evan-Williams.webp",
    tags: ["twitter", "microblogging", "real-time communication", "social media", "Jack Dorsey, Noah Glass, Biz Stone & Evan Williams"]
  },
  {
    id: 20,
    title: "LinkedIn: Professional Networking",
    excerpt: "The platform that digitized professional networking, transforming career development and business relationship building in the digital age.",
    category: "Technology",
    author: "Reid Hoffman",
    date: "2024-04-15",
    readTime: "8 min read",
    image: "/media/technologyImg/Reid-Hoffman.jpeg",
    tags: ["linkedin", "professional networking", "career development", "business", "Reid Hoffman"]
  },
  {
    id: 21,
    title: "Dropbox: Cloud Storage Innovation",
    excerpt: "The service that simplified file sharing and storage in the cloud, making documents accessible from anywhere and enabling seamless collaboration.",
    category: "Technology",
    author: "Drew Houston & Arash Ferdowsi",
    date: "2024-04-20",
    readTime: "6 min read",
    image: "/media/technologyImg/Drew-Houston&Arash-Ferdowsi.jpg",
    tags: ["dropbox", "cloud storage", "file sharing", "collaboration", "Drew Houston & Arash Ferdowsi"]
  },
  {
    id: 22,
    title: "Skype: Voice over Internet Protocol",
    excerpt: "The pioneering VoIP service that made international calling affordable and accessible, connecting families and businesses across continents.",
    category: "Technology",
    author: "Niklas Zennström & Janus Friis",
    date: "2024-04-25",
    readTime: "7 min read",
    image: "/media/technologyImg/Niklas-Zennström&Janus-Friis.jpg",
    tags: ["skype", "voip", "video calling", "international communication", "Niklas Zennström & Janus Friis"]
  },
  {
    id: 23,
    title: "GitHub: Code Collaboration Platform",
    excerpt: "The platform that revolutionized software development through version control and collaboration, becoming essential for programmers worldwide.",
    category: "Technology",
    author: "Tom Preston-Werner, Chris Wanstrath & PJ Hyett",
    date: "2024-04-30",
    readTime: "10 min read",
    image: "/media/technologyImg/Tom-Preston-Werner, Chris-Wanstrath&PJ-Hyett.webp",
    tags: ["github", "version control", "software development", "collaboration", "Tom Preston-Werner, Chris Wanstrath & PJ Hyett"]
  },
  {
    id: 24,
    title: "Salesforce: Customer Relationship Management",
    excerpt: "The cloud-based CRM that transformed how businesses manage customer relationships and pioneered Software as a Service (SaaS) model.",
    category: "Technology",
    author: "Marc Benioff",
    date: "2024-05-01",
    readTime: "9 min read",
    image: "/media/technologyImg/Marc-Benioff.jpg",
    tags: ["salesforce", "crm", "saas", "customer management", "Marc Benioff"]
  },
  {
    id: 25,
    title: "Adobe Photoshop: Digital Image Revolution",
    excerpt: "The image editing software that transformed photography and digital art, creating new possibilities for visual creativity and manipulation.",
    category: "Technology",
    author: "Thomas Knoll & John Knoll",
    date: "2024-05-05",
    readTime: "11 min read",
    image: "/media/technologyImg/Thomas-Knoll&John-Knoll.jpg",
    tags: ["photoshop", "image editing", "digital photography", "visual arts", "Thomas Knoll & John Knoll"]
  },
  {
    id: 26,
    title: "Microsoft Windows: Personal Computing Revolution",
    excerpt: "The operating system that brought graphical user interfaces to personal computers, making computing accessible to millions worldwide.",
    category: "Technology",
    author: "Bill Gates & Paul Allen",
    date: "2024-05-10",
    readTime: "8 min read",
    image: "/media/technologyImg/Bill-Gates&Paul-Allen.jpg",
    tags: ["microsoft", "windows", "operating system", "personal computing","Bill Gates & Paul Allen", "software"]
  },
  {
    id: 27,
    title: "WordPress: Website Creation Platform",
    excerpt: "The content management system that democratized web publishing, powering millions of websites and blogs across the internet.",
    category: "Technology",
    author: "Matt Mullenweg & Mike Little",
    date: "2024-05-15",
    readTime: "7 min read",
    image: "/media/technologyImg/Matt-Mullenweg&Mike-Little.jpeg",
    tags: ["wordpress", "cms", "web publishing", "blogging", "Matt Mullenweg & Mike Little"]
  },
  {
    id: 28,
    title: "Oracle Database: Enterprise Data Management",
    excerpt: "The relational database system that became the backbone of enterprise computing, managing critical business data for major corporations.",
    category: "Technology",
    author: "Larry Ellison, Bob Miner & Ed Oates",
    date: "2024-05-20",
    readTime: "10 min read",
    image: "/media/technologyImg/Larry-Ellison, Bob-Miner&Ed-Oates.webp",
    tags: ["oracle", "database", "enterprise software", "data management", "Larry Ellison, Bob Miner & Ed Oates"]
  },
  {
    id: 29,
    title: "AutoCAD: Computer-Aided Design",
    excerpt: "The software that revolutionized engineering and architectural design, replacing traditional drafting with precise digital modeling.",
    category: "Technology",
    author: "John Walker",
    date: "2024-05-25",
    readTime: "9 min read",
    image: "/media/technologyImg/John-Walker.jpg",
    tags: ["autocad", "cad", "engineering design", "architecture", "John Walker"]
  },
  {
    id: 30,
    title: "eBay: Online Auction Revolution",
    excerpt: "The platform that created the first major online marketplace, revolutionizing how people buy and sell goods worldwide.",
    category: "Technology",
    author: "Pierre Omidyar",
    date: "2024-06-01",
    readTime: "8 min read",
    image: "/media/technologyImg/Pierre-Omidyar.avif",
    tags: ["ebay", "online marketplace", "e-commerce", "auctions", "Pierre Omidyar"]
  },
  {
    id: 31,
    title: "Java Programming Language: Write Once, Run Anywhere",
    excerpt: "The programming language that revolutionized software development with platform independence and object-oriented programming principles.",
    category: "Technology",
    author: "James Gosling",
    date: "2024-06-05",
    readTime: "11 min read",
    image: "/media/technologyImg/James-Gosling.jpg",
    tags: ["java", "programming language", "software development", "cross-platform", "James Gosling"]
  },
  {
    id: 32,
    title: "MySQL: Open Source Database",
    excerpt: "The open-source database that powered the early web, making robust data management accessible to developers and small businesses worldwide.",
    category: "Technology",
    author: "Michael Widenius & David Axmark",
    date: "2024-06-10",
    readTime: "7 min read",
    image: "/media/technologyImg/Michael-Widenius&David-Axmark.jpg",
    tags: ["mysql", "database", "open source", "web development", "Michael Widenius & David Axmark"]
  },
  {
    id: 33,
    title: "Apache Web Server: Powering the Internet",
    excerpt: "The open-source web server that became the foundation of the internet, serving millions of websites with reliability and flexibility.",
    category: "Technology",
    author: "Robert McCool",
    date: "2024-06-15",
    readTime: "6 min read",
    image: "/media/technologyImg/Robert-McCool.png",
    tags: ["apache", "web server", "open source", "internet infrastructure", "Robert McCool"]
  },
  {
    id: 34,
    title: "Linux Operating System: Open Source Revolution",
    excerpt: "The open-source operating system that challenged proprietary software and became the backbone of modern internet infrastructure.",
    category: "Technology",
    author: "Linus Torvalds",
    date: "2024-06-20",
    readTime: "12 min read",
    image: "/media/technologyImg/Linus-Torvalds.webp",
    tags: ["linux", "operating system", "open source", "unix", "Linus Torvalds"]
  },
  {
    id: 35,
    title: "Mozilla Firefox: Open Web Browser",
    excerpt: "The open-source browser that challenged Internet Explorer's dominance and championed web standards and user privacy.",
    category: "Technology",
    author: "Blake Ross & Dave Hyatt",
    date: "2024-06-25",
    readTime: "8 min read",
    image: "/media/technologyImg/Blake-Ross&David-Hyatt.jpg",
    tags: ["firefox", "web browser", "open source", "privacy", "Blake Ross & Dave Hyatt"]
  },
  {
    id: 36,
    title: "VLC Media Player: Universal Media Solution",
    excerpt: "The open-source media player that could play any video or audio format, solving compatibility issues for users worldwide.",
    category: "Technology",
    author: "Jean-Baptiste Kempf & VideoLAN Team",
    date: "2024-07-01",
    readTime: "5 min read",
    image: "/media/technologyImg/Jean-Baptist.webp",
    tags: ["vlc", "media player", "open source", "multimedia", "Jean-Baptiste Kempf & VideoLAN Team"]
  },
  {
    id: 37,
    title: "Discord: Gaming Communication Platform",
    excerpt: "The voice and text chat platform that revolutionized gaming communication and built thriving online communities worldwide.",
    category: "Technology",
    author: "Jason Citron & Stan Vishnevsky",
    date: "2024-07-05",
    readTime: "9 min read",
    image: "/media/technologyImg/Jason-Citron&Stan-Vishnevsky.webp",
    tags: ["discord", "gaming", "communication", "community", "Jason Citron & Stan Vishnevsky"]
  },
  {
    id: 38,
    title: "Twitch: Live Streaming Revolution",
    excerpt: "The platform that transformed gaming into a spectator sport and created new career opportunities for content creators and streamers.",
    category: "Technology",
    author: "Justin Kan & Emmett Shear",
    date: "2024-07-10",
    readTime: "10 min read",
    image: "/media/technologyImg/Justin-Kan&Emmett-Shear.jpg",
    tags: ["twitch", "live streaming", "gaming", "content creation", "Justin Kan & Emmett Shear"]
  },
  {
    id: 39,
    title: "Snapchat: Ephemeral Messaging Innovation",
    excerpt: "The app that introduced disappearing messages and augmented reality filters, changing how young people communicate and share moments.",
    category: "Technology",
    author: "Evan Spiegel, Bobby Murphy & Reggie Brown",
    date: "2024-07-15",
    readTime: "7 min read",
    image: "/media/technologyImg/Evan-Spiegel, Bobby-Murphy&Reggie-Brown.webp",
    tags: ["snapchat", "ephemeral messaging", "ar filters", "social media", "Evan Spiegel, Bobby Murphy & Reggie Brown"]
  },
  {
    id: 40,
    title: "Pinterest: Visual Discovery Platform",
    excerpt: "The platform that organized the internet's visual content into discoverable boards, inspiring creativity and lifestyle choices globally.",
    category: "Technology",
    author: "Ben Silbermann, Paul Sciarra & Evan Sharp",
    date: "2024-07-20",
    readTime: "6 min read",
    image: "/media/technologyImg/Ben-Silbermann, Paul-Sciarra&Evan-Sharp.jpg",
    tags: ["pinterest", "visual discovery", "inspiration", "lifestyle","Ben Silbermann, Paul Sciarra & Evan Sharp"]
  },
  {
    id: 41,
    title: "Oculus VR: Virtual Reality Revolution",
    excerpt: "The virtual reality headset that brought immersive gaming and experiences to consumers, kickstarting the modern VR industry.",
    category: "Technology",
    author: "Palmer Luckey",
    date: "2024-07-25",
    readTime: "11 min read",
    image: "/media/technologyImg/Palmer-Luckey.webp",
    tags: ["oculus", "virtual reality", "vr", "immersive technology", "Palmer Luckey"]
  },
  {
    id: 42,
    title: "Ethereum: Smart Contract Platform",
    excerpt: "The blockchain platform that enabled programmable contracts and decentralized applications, expanding cryptocurrency beyond digital money.",
    category: "Technology",
    author: "Vitalik Buterin",
    date: "2024-08-01",
    readTime: "13 min read",
    image: "/media/technologyImg/Vitalik-Buterin.png",
    tags: ["ethereum", "blockchain", "smart contracts", "defi", "Vitalik Buterin"]
  },
  {
    id: 43,
    title: "Unity Game Engine: Democratizing Game Development",
    excerpt: "The game development platform that made creating games accessible to indie developers and powered countless mobile and indie games.",
    category: "Technology",
    author: "David Helgason, Nicholas Francis & Joachim Ante",
    date: "2024-08-05",
    readTime: "9 min read",
    image: "/media/technologyImg/David-Helgason, Nicholas-Francis&Joachim-Ante.jpg",
    tags: ["unity", "game engine", "game development", "indie games", "David Helgason, Nicholas Francis & Joachim Ante"]
  },
  {
    id: 44,
    title: "Figma: Collaborative Design Platform",
    excerpt: "The web-based design tool that revolutionized design collaboration, enabling real-time teamwork and browser-based design workflows.",
    category: "Technology",
    author: "Dylan Field & Evan Wallace",
    date: "2024-08-10",
    readTime: "8 min read",
    image: "/media/technologyImg/Dylan-Field&Evan-Wallace.webp",
    tags: ["figma", "design tool", "collaboration", "ui design", "Dylan Field & Evan Wallace"]
  },
  {
    id: 45,
    title: "Stripe: Online Payment Infrastructure",
    excerpt: "The payment processing platform that simplified online transactions for businesses, enabling the growth of e-commerce and digital services.",
    category: "Technology",
    author: "Patrick Collison & John Collison",
    date: "2024-08-15",
    readTime: "7 min read",
    image: "/media/technologyImg/Patrick-Collison&John-Collison.jpg",
    tags: ["stripe", "payment processing", "fintech", "e-commerce", "Patrick Collison & John Collison"]
  },
  {
    id: 46,
    title: "Notion: All-in-One Workspace",
    excerpt: "The productivity platform that combined notes, databases, and project management into one flexible workspace for teams and individuals.",
    category: "Technology",
    author: "Ivan Zhao & Simon Last",
    date: "2024-08-20",
    readTime: "6 min read",
    image: "/media/technologyImg/Ivan-Zhao&Simon-Last.png",
    tags: ["notion", "productivity", "workspace", "collaboration", "Ivan Zhao & Simon Last"]
  },
  {
    id: 47,
    title: "Shopify: E-commerce Platform",
    excerpt: "The platform that democratized online selling, enabling millions of entrepreneurs to start their own e-commerce businesses easily.",
    category: "Technology",
    author: "Tobias Lütke, Daniel Weinand & Scott Lake",
    date: "2024-08-25",
    readTime: "9 min read",
    image: "/media/technologyImg/Tobias-Lütke, Daniel-Weinand&Scott-Lake.jpg",
    tags: ["shopify", "e-commerce", "online store", "entrepreneurship", "Tobias Lütke, Daniel Weinand & Scott Lake"]
  },
  {
    id: 48,
    title: "Django Web Framework: Rapid Web Development",
    excerpt: "The Python web framework that accelerated web development with its 'batteries included' philosophy and emphasis on rapid prototyping.",
    category: "Technology",
    author: "Adrian Holovaty & Simon Willison",
    date: "2024-09-01",
    readTime: "8 min read",
    image: "/media/technologyImg/Adrian-Holovaty&Simon-Willison.jpg",
    tags: ["django", "web framework", "python", "web development", "Adrian Holovaty & Simon Willison"]
  },
  {
    id: 49,
    title: "React JavaScript Library: Component-Based UI",
    excerpt: "The JavaScript library that revolutionized front-end development with reusable components and efficient virtual DOM rendering.",
    category: "Technology",
    author: "Jordan Walke",
    date: "2024-09-05",
    readTime: "10 min read",
    image: "/media/technologyImg/Jordan-Walke.jpg",
    tags: ["react", "javascript", "frontend", "user interface", "Jordan Walke"]
  },
  {
    id: 50,
    title: "Docker: Containerization Revolution",
    excerpt: "The platform that revolutionized software deployment through containerization, making applications portable and scalable across environments.",
    category: "Technology",
    author: "Solomon Hykes",
    date: "2024-09-10",
    readTime: "11 min read",
    image: "/media/technologyImg/Solomon-Hykes.jpg",
    tags: ["docker", "containerization", "devops", "deployment", "Solomon Hykes"]
  },


  // Sports category

  {
    id: 51,
    title: "Lionel Messi: The GOAT's Journey to Greatness",
    excerpt: "From Barcelona's La Masia to PSG and World Cup glory, explore the career of football's most decorated player.",
    category: "Sports",
    author: "Football Analyst",
    date: "2024-03-15",
    readTime: "8 min read",
    image: "/media/sportsImg/Lionel-Messi.jpg",
    tags: ["messi", "barcelona", "argentina", "goat"]
  },
  {
    id: 52,
    title: "Cristiano Ronaldo: The Machine's Relentless Pursuit",
    excerpt: "Five Ballon d'Or wins, multiple Champions League titles, and records that may never be broken.",
    category: "Sports",
    author: "Sports Writer",
    date: "2024-03-12",
    readTime: "9 min read",
    image: "/media/sportsImg/Cristiano-Ronaldo.avif",
    tags: ["ronaldo", "portugal", "manchester-united", "records"]
  },
  {
    id: 53,
    title: "Pelé: The King Who Defined Football",
    excerpt: "Three World Cups, over 1000 goals, and the man who made football beautiful for generations.",
    category: "Sports",
    author: "Football Historian",
    date: "2024-02-28",
    readTime: "10 min read",
    image: "/media/sportsImg/Pelé.webp",
    tags: ["pele", "brazil", "legend", "world-cup"]
  },
  {
    id: 54,
    title: "Diego Maradona: The Hand of God and Feet of Magic",
    excerpt: "From Naples to the World Cup, the controversial genius who captivated the football world.",
    category: "Sports",
    author: "Sports Journalist",
    date: "2024-02-25",
    readTime: "8 min read",
    image: "/media/sportsImg/Diego-Maradona.jpg",
    tags: ["maradona", "argentina", "napoli", "genius"]
  },
  {
    id: 55,
    title: "Johan Cruyff: The Dutch Master's Total Football",
    excerpt: "Revolutionary player and coach who changed football philosophy forever with his innovative approach.",
    category: "Sports",
    author: "Tactical Expert",
    date: "2024-02-20",
    readTime: "7 min read",
    image: "/media/sportsImg/Johan-Cruyff.webp",
    tags: ["cruyff", "netherlands", "barcelona", "total-football"]
  },
  {
    id: 56,
    title: "Zinedine Zidane: Poetry in Motion",
    excerpt: "The French maestro whose elegance and skill made him one of the most admired players ever.",
    category: "Sports",
    author: "Football Expert",
    date: "2024-02-18",
    readTime: "6 min read",
    image: "/media/sportsImg/Zinedine-Zidane.jpg",
    tags: ["zidane", "france", "real-madrid", "elegance"]
  },
  {
    id: 57,
    title: "Ronaldinho: The Smile That Lit Up Football",
    excerpt: "Brazilian magic, impossible skills, and the joy of football personified in one extraordinary player.",
    category: "Sports",
    author: "Sports Writer",
    date: "2024-02-15",
    readTime: "7 min read",
    image: "/media/sportsImg/Ronaldinho.webp",
    tags: ["ronaldinho", "brazil", "barcelona", "skills"]
  },
  {
    id: 58,
    title: "Ronaldo Nazário: The Original Phenomenon",
    excerpt: "Speed, power, and clinical finishing made R9 one of the most feared strikers in football history.",
    category: "Sports",
    author: "Football Analyst",
    date: "2024-02-12",
    readTime: "8 min read",
    image: "/media/sportsImg/Ronaldo-Nazarioo.jpg",
    tags: ["ronaldo-nazario", "brazil", "phenomenon", "striker"]
  },
  {
    id: 59,
    title: "Thierry Henry: Arsenal's King and France's Hero",
    excerpt: "The striker who combined pace, power, and precision to become a Premier League legend.",
    category: "Sports",
    author: "Premier League Expert",
    date: "2024-02-10",
    readTime: "7 min read",
    image: "/media/sportsImg/Thierry-Henry.avif",
    tags: ["henry", "arsenal", "france", "striker"]
  },
  {
    id: 60,
    title: "Kaká: The Last Ballon d'Or Before Messi and Ronaldo",
    excerpt: "Brazilian elegance and attacking prowess that dominated European football in the 2000s.",
    category: "Sports",
    author: "Football Writer",
    date: "2024-02-08",
    readTime: "6 min read",
    image: "/media/sportsImg/Kaká.jpg",
    tags: ["kaka", "brazil", "milan", "ballon-dor"]
  },
  {
    id: 61,
    title: "Roberto Baggio: The Divine Ponytail's Artistry",
    excerpt: "Italian genius whose creativity and passion made him one of the most beloved players ever.",
    category: "Sports",
    author: "Italian Football Expert",
    date: "2024-02-05",
    readTime: "7 min read",
    image: "/media/sportsImg/Roberto-Baggio.jpeg",
    tags: ["baggio", "italy", "juventus", "creativity"]
  },
  {
    id: 62,
    title: "Xavi Hernández: The Metronome of Barcelona",
    excerpt: "Master of possession football whose vision and passing defined a generation of Spanish success.",
    category: "Sports",
    author: "Tactical Analyst",
    date: "2024-02-03",
    readTime: "6 min read",
    image: "/media/sportsImg/Xavi-Hernández.jpg",
    tags: ["xavi", "barcelona", "spain", "passing"]
  },
  {
    id: 63,
    title: "Andrés Iniesta: The Pale Faced Assassin",
    excerpt: "Quiet genius whose moments of magic included the most important goal in Spanish football history.",
    category: "Sports",
    author: "Spanish Football Writer",
    date: "2024-02-01",
    readTime: "6 min read",
    image: "/media/sportsImg/Andrés-Iniesta.avif",
    tags: ["iniesta", "barcelona", "spain", "world-cup"]
  },
  {
    id: 64,
    title: "Francesco Totti: Roma's Eternal Captain",
    excerpt: "One club legend whose loyalty and skill made him the embodiment of Italian football passion.",
    category: "Sports",
    author: "Serie A Expert",
    date: "2024-01-30",
    readTime: "8 min read",
    image: "/media/sportsImg/Francesco-Totti.jpg",
    tags: ["totti", "roma", "italy", "loyalty"]
  },
  {
    id: 65,
    title: "Paolo Maldini: The Gentleman Defender",
    excerpt: "AC Milan legend whose elegance and leadership defined defensive excellence for over two decades.",
    category: "Sports",
    author: "Defensive Specialist",
    date: "2024-01-28",
    readTime: "7 min read",
    image: "/media/sportsImg/Paolo-Maldini.jpg",
    tags: ["maldini", "milan", "italy", "defender"]
  },
  {
    id: 66,
    title: "Franco Baresi: The Sweeper Supreme",
    excerpt: "AC Milan's heart and soul, the defender who redefined the role with intelligence and leadership.",
    category: "Sports",
    author: "Italian Football Historian",
    date: "2024-01-25",
    readTime: "7 min read",
    image: "/media/sportsImg/Franco-Baresi.webp",
    tags: ["baresi", "milan", "italy", "sweeper"]
  },
  {
    id: 67,
    title: "Gianluigi Buffon: The Goalkeeper's Goalkeeper",
    excerpt: "Italian legend whose longevity and shot-stopping ability made him one of the greatest keepers ever.",
    category: "Sports",
    author: "Goalkeeper Expert",
    date: "2024-01-23",
    readTime: "6 min read",
    image: "/media/sportsImg/Gianluigi-Buffon.avif",
    tags: ["buffon", "juventus", "italy", "goalkeeper"]
  },
  {
    id: 68,
    title: "Raúl González: Real Madrid's Eternal Prince",
    excerpt: "The Spanish forward whose loyalty and goalscoring prowess made him a Bernabéu icon.",
    category: "Sports",
    author: "Real Madrid Expert",
    date: "2024-01-20",
    readTime: "7 min read",
    image: "/media/sportsImg/Raúl-González.jpg",
    tags: ["raul", "real-madrid", "spain", "loyalty"]
  },
  {
    id: 69,
    title: "David Beckham: The Global Icon",
    excerpt: "From Manchester United to global stardom, the midfielder who transcended football.",
    category: "Sports",
    author: "Sports Marketing Expert",
    date: "2024-01-18",
    readTime: "8 min read",
    image: "/media/sportsImg/David-Beckham.webp",
    tags: ["beckham", "manchester-united", "england", "icon"]
  },
  {
    id: 70,
    title: "Steven Gerrard: Liverpool's Heartbeat",
    excerpt: "The captain who embodied Liverpool's never-say-die spirit and delivered in the biggest moments.",
    category: "Sports",
    author: "Liverpool Correspondent",
    date: "2024-01-15",
    readTime: "7 min read",
    image: "/media/sportsImg/Steven-Gerrard.avif",
    tags: ["gerrard", "liverpool", "england", "captain"]
  },
  {
    id: 71,
    title: "Frank Lampard: The Goalscoring Midfielder",
    excerpt: "Chelsea legend whose intelligence and shooting ability redefined the midfielder's role.",
    category: "Sports",
    author: "Chelsea Expert",
    date: "2024-01-13",
    readTime: "6 min read",
    image: "/media/sportsImg/Frank-Lampard.webp",
    tags: ["lampard", "chelsea", "england", "midfielder"]
  },
  {
    id: 72,
    title: "Paul Scholes: The Ginger Prince of Old Trafford",
    excerpt: "Manchester United's midfield maestro whose passing and vision were second to none.",
    category: "Sports",
    author: "Manchester United Writer",
    date: "2024-01-10",
    readTime: "6 min read",
    image: "/media/sportsImg/Paul-Scholes.jpg",
    tags: ["scholes", "manchester-united", "england", "passing"]
  },
  {
    id: 73,
    title: "Rio Ferdinand: The Ball-Playing Defender",
    excerpt: "English center-back who combined defensive solidity with exceptional ball-playing ability.",
    category: "Sports",
    author: "Defensive Analyst",
    date: "2024-01-08",
    readTime: "6 min read",
    image: "/media/sportsImg/Rio-Ferdinand.webp",
    tags: ["ferdinand", "manchester-united", "england", "defender"]
  },
  {
    id: 74,
    title: "John Terry: Chelsea's Brave Heart",
    excerpt: "The captain who led by example and embodied the fighting spirit of Chelsea's golden era.",
    category: "Sports",
    author: "Premier League Analyst",
    date: "2024-01-05",
    readTime: "7 min read",
    image: "/media/sportsImg/John-Terry.webp",
    tags: ["terry", "chelsea", "england", "captain"]
  },
  {
    id: 75,
    title: "Alan Shearer: England's Premier League King",
    excerpt: "The striker whose goalscoring records and leadership made him a Premier League legend.",
    category: "Sports",
    author: "English Football Expert",
    date: "2024-01-03",
    readTime: "7 min read",
    image: "/media/sportsImg/Alan-Shearer.avif",  
    tags: ["shearer", "newcastle", "england", "goals"]
  },
  {
    id: 76,
    title: "Michael Owen: The Boy Wonder",
    excerpt: "English striker whose pace and finishing ability announced him as a global superstar at 18.",
    category: "Sports",
    author: "Football Historian",
    date: "2023-12-30",
    readTime: "6 min read",
    image: "/media/sportsImg/Michael-Owen.jpg",
    tags: ["owen", "liverpool", "england", "pace"]
  },
  {
    id: 77,
    title: "Ryan Giggs: The Welsh Wizard's Wing Magic",
    excerpt: "Manchester United legend whose longevity and wing play defined an era at Old Trafford.",
    category: "Sports",
    author: "Manchester United Historian",
    date: "2023-12-28",
    readTime: "8 min read",
    image: "/media/sportsImg/Ryan-Giggs.avif",
    tags: ["giggs", "manchester-united", "wales", "winger"]
  },
  {
    id: 78,
    title: "Gareth Bale: Wales' Dragon on the Wing",
    excerpt: "The Welsh winger whose pace and power took him from Tottenham to Real Madrid glory.",
    category: "Sports",
    author: "Welsh Football Writer",
    date: "2023-12-25",
    readTime: "7 min read",
    image: "/media/sportsImg/Gareth-Bale.jpg",
    tags: ["bale", "real-madrid", "wales", "pace"]
  },
  {
    id: 79,
    title: "Luka Modrić: The Ballon d'Or Midfield Magician",
    excerpt: "Croatian maestro who broke the Messi-Ronaldo duopoly and defined modern midfield play.",
    category: "Sports",
    author: "Midfield Specialist",
    date: "2023-12-23",
    readTime: "7 min read",
    image: "/media/sportsImg/Luka-Modrić.jpg",
    tags: ["modric", "real-madrid", "croatia", "ballon-dor"]
  },
  {
    id: 80,
    title: "Bastian Schweinsteiger: Germany's Midfield General",
    excerpt: "Bayern Munich and Germany legend whose leadership guided his country to World Cup glory.",
    category: "Sports",
    author: "German Football Expert",
    date: "2023-12-20",
    readTime: "7 min read",
    image: "/media/sportsImg/Bastian-Schweinsteiger.jpg",
    tags: ["schweinsteiger", "bayern", "germany", "world-cup"]
  },
  {
    id: 81,
    title: "Philipp Lahm: The Perfect Captain",
    excerpt: "Bayern Munich's versatile defender whose intelligence and leadership were unmatched.",
    category: "Sports",
    author: "Bundesliga Analyst",
    date: "2023-12-18",
    readTime: "6 min read",
    image: "/media/sportsImg/Philipp-Lahm.jpg",
    tags: ["lahm", "bayern", "germany", "captain"]
  },
  {
    id: 82,
    title: "Manuel Neuer: The Sweeper Keeper Revolution",
    excerpt: "German goalkeeper who redefined the position with his revolutionary playing style.",
    category: "Sports",
    author: "Goalkeeper Expert",
    date: "2023-12-15",
    readTime: "6 min read",
    image: "/media/sportsImg/Manuel-Neuer.jpg",
    tags: ["neuer", "bayern", "germany", "goalkeeper"]
  },
  {
    id: 83,
    title: "Miroslav Klose: Germany's World Cup Hero",
    excerpt: "The striker who became the World Cup's all-time leading goalscorer with German efficiency.",
    category: "Sports",
    author: "World Cup Expert",
    date: "2023-12-13",
    readTime: "7 min read",
    image: "/media/sportsImg/Miroslav-Klose.webp",
    tags: ["klose", "germany", "world-cup", "goals"]
  },
  {
    id: 84,
    title: "Andrea Pirlo: The Architect of Football",
    excerpt: "/media/sportsImg/Lionel-Messi.jpg",
    category: "Sports",
    author: "Tactical Expert",
    date: "2023-12-10",
    readTime: "7 min read",
    image: "/media/sportsImg/Andrea-Pirlo.jpg",
    tags: ["pirlo", "juventus", "italy", "playmaker"]
  },
  {
    id: 85,
    title: "Fabio Cannavaro: The World Cup Winning Captain",
    excerpt: "Italian defender who captained his country to World Cup glory and won the Ballon d'Or.",
    category: "Sports",
    author: "Italian Football Writer",
    date: "2023-12-08",
    readTime: "6 min read",
    image: "/media/sportsImg/Fabio-Cannavaro.jpg",
    tags: ["cannavaro", "italy", "world-cup", "defender"]
  },
  {
    id: 86,
    title: "Karim Benzema: Real Madrid's Clinical Finisher",
    excerpt: "French striker whose evolution into a complete forward earned him the Ballon d'Or.",
    category: "Sports",
    author: "La Liga Expert",
    date: "2023-12-05",
    readTime: "7 min read",
    image: "/media/sportsImg/Karim-Benzema.avif",
    tags: ["benzema", "real-madrid", "france", "striker"]
  },
  {
    id: 87,
    title: "Neymar Jr: Brazilian Flair in the Modern Era",
    excerpt: "The most expensive player ever whose skill and creativity carry on Brazil's rich tradition.",
    category: "Sports",
    author: "Brazilian Football Expert",
    date: "2023-12-03",
    readTime: "8 min read",
    image: "/media/sportsImg/Neymar-Jr.jpg",
    tags: ["neymar", "brazil", "psg", "skills"]
  },
  {
    id: 88,
    title: "Kevin De Bruyne: Manchester City's Assist King",
    excerpt: "Belgian midfielder whose vision and passing ability have redefined the modern playmaker role.",
    category: "Sports",
    author: "Premier League Analyst",
    date: "2023-12-01",
    readTime: "6 min read",
    image: "/media/sportsImg/Kevin-De-Bruyne.webp",
    tags: ["de-bruyne", "manchester-city", "belgium", "assists"]
  },
  {
    id: 89,
    title: "Virgil van Dijk: The Colossus of Defense",
    excerpt: "Dutch defender whose arrival transformed Liverpool's defense and led them to glory.",
    category: "Sports",
    author: "Defensive Specialist",
    date: "2023-11-29",
    readTime: "6 min read",
    image: "/media/sportsImg/Virgil-van-Dijk.jpg",
    tags: ["van-dijk", "liverpool", "netherlands", "defender"]
  },
  {
    id: 90,
    title: "Robert Lewandowski: The Goal Machine",
    excerpt: "Polish striker whose consistency and clinical finishing made him one of the world's best.",
    category: "Sports",
    author: "Bundesliga Expert",
    date: "2023-11-27",
    readTime: "7 min read",
    image: "/media/sportsImg/Robert-Lewandowski.jpg",
    tags: ["lewandowski", "bayern", "poland", "goals"]
  },
  {
    id: 91,
    title: "Mohamed Salah: The Egyptian King",
    excerpt: "Liverpool's Egyptian winger whose pace and finishing have made him a Premier League icon.",
    category: "Sports",
    author: "Liverpool Writer",
    date: "2023-11-25",
    readTime: "7 min read",
    image: "/media/sportsImg/Mohamed-Salah.jpg",
    tags: ["salah", "liverpool", "egypt", "winger"]
  },
  {
    id: 92,
    title: "Sadio Mané: Senegal's Speed Demon",
    excerpt: "The winger whose pace, work rate, and finishing ability made him a key player for club and country.",
    category: "Sports",
    author: "African Football Expert",
    date: "2023-11-23",
    readTime: "6 min read",
    image: "/media/sportsImg/Sadio-Mané.jpg",
    tags: ["mane", "liverpool", "senegal", "pace"]
  },
  {
    id: 93,
    title: "Kylian Mbappé: The Future of Football",
    excerpt: "French sensation whose speed and finishing ability mark him as the next global superstar.",
    category: "Sports",
    author: "French Football Writer",
    date: "2023-11-20",
    readTime: "8 min read",
    image: "/media/sportsImg/Kylian-Mbappé.jpg",
    tags: ["mbappe", "psg", "france", "future"]
  },
  {
    id: 94,
    title: "Erling Haaland: The Norwegian Goal Monster",
    excerpt: "The striker whose physical presence and clinical finishing have taken the football world by storm.",
    category: "Sports",
    author: "Striker Specialist",
    date: "2023-11-18",
    readTime: "7 min read",
    image: "/media/sportsImg/Erling-Haaland.jpg",
    tags: ["haaland", "manchester-city", "norway", "goals"]
  },
  {
    id: 95,
    title: "N'Golo Kanté: The Smiling Destroyer",
    excerpt: "French midfielder whose work rate and ball-winning ability made him indispensable for club and country.",
    category: "Sports",
    author: "Midfield Expert",
    date: "2023-11-15",
    readTime: "6 min read",
    image: "/media/sportsImg/N'Golo-Kanté.jpg",
    tags: ["kante", "chelsea", "france", "midfielder"]
  },
  {
    id: 96,
    title: "Sergio Ramos: Real Madrid's Warrior Captain",
    excerpt: "Spanish defender whose leadership, headers, and last-minute goals defined Real Madrid's success.",
    category: "Sports",
    author: "Real Madrid Correspondent",
    date: "2023-11-13",
    readTime: "8 min read",
    image: "/media/sportsImg/Sergio-Ramos.webp",
    tags: ["ramos", "real-madrid", "spain", "captain"]
  },
  {
    id: 97,
    title: "Sergio Agüero: Manchester City's Clutch Performer",
    excerpt: "Argentine striker whose crucial goals and technical ability made him a Premier League legend.",
    category: "Sports",
    author: "Manchester City Expert",
    date: "2023-11-10",
    readTime: "7 min read",
    image: "/media/sportsImg/Sergio-Agüero.webp",
    tags: ["aguero", "manchester-city", "argentina", "clutch"]
  },
  {
    id: 98,
    title: "Luis Suárez: The Controversial Genius",
    excerpt: "Uruguayan striker whose skill and determination made him one of the most effective forwards ever.",
    category: "Sports",
    author: "South American Expert",
    date: "2023-11-08",
    readTime: "7 min read",
    image: "/media/sportsImg/Luis-Suárez.jpeg",
    tags: ["suarez", "barcelona", "uruguay", "striker"]
  },
  {
    id: 99,
    title: "Eden Hazard: Belgium's Dribbling Maestro",
    excerpt: "The winger whose close control and dribbling ability made him one of the most entertaining players to watch.",
    category: "Sports",
    author: "Belgian Football Writer",
    date: "2023-11-05",
    readTime: "6 min read",
    image: "/media/sportsImg/Eden-Hazard.avif",
    tags: ["hazard", "chelsea", "belgium", "dribbling"]
  },
  {
    id: 100,
    title: "Didier Drogba: Chelsea's Ivory Coast Legend",
    excerpt: "The striker whose power, presence, and big-game performances made him a Blues icon.",
    category: "Sports",
    author: "African Football Specialist",
    date: "2023-11-03",
    readTime: "7 min read",
    image: "/media/sportsImg/Didier-Drogba.jpg",
    tags: ["drogba", "chelsea", "ivory-coast", "power"]
  }
];

export default BLOG_POSTS;
